import {
    AuthenticationServiceError,
    type ServerAuthenticationEntryPoint,
    type ServerAuthenticationFailureHandler
} from './types.ts';

export const serverAuthenticationEntryPointFailureHandler = (opts: {
    entryPoint: ServerAuthenticationEntryPoint,
    rethrowAuthenticationServiceError?: boolean
}): ServerAuthenticationFailureHandler => {
    const entryPoint = opts.entryPoint;
    const rethrowAuthenticationServiceError = opts?.rethrowAuthenticationServiceError ?? true;
    return async ({exchange}, error) => {
        if (!rethrowAuthenticationServiceError) {
            return entryPoint(exchange, error);
        }
        if (!(error instanceof AuthenticationServiceError)) {
            return entryPoint(exchange, error);
        }
        throw error;

    };


}
